import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface FilterBarSliderProps {
  children?: React.ReactNode;
}

const FilterBarSlider = ({ children }: FilterBarSliderProps) => {
  const { t } = useTranslation('search');
  const [translate, setTranslate] = useState(0);
  const [max, setMax] = useState(0);
  const listReference = useRef<HTMLDivElement | null>(null);

  const onPrev = () => setTranslate(0 < translate - 100 ? translate - 100 : 0);
  const onNext = () => setTranslate(max < translate + 100 ? max : translate + 100);

  useEffect(() => {
    if (listReference && listReference.current) {
      let maxSize = listReference.current.children.length * 2 + 50;
      for (let i = 0; i < listReference.current.children.length; i++) {
        maxSize += listReference.current.children[i].clientWidth;
      }
      setMax(maxSize - listReference.current.clientWidth);
    }
  }, [listReference]);

  return (
    <div className="action-group-container-main">
      <div data-wx-actiongroup="">
        <div className="action-group-clip">
          <div
            className="action-group-list"
            ref={listReference}
            style={translate > 0 ? { transform: `translateX(${-1 * translate}px)` } : undefined}
          >
            {children}
          </div>
        </div>
        <div
          className="action-group-nav action-group-nav-prev"
          style={{ display: !translate ? undefined : 'block' }}
        >
          <button
            type="button"
            data-wx-actionbutton=""
            title={t('Previous filter', { ns: 'search' })}
            onClick={onPrev}
          >
            <i className="icon-chevron-left no-margin" />
          </button>
        </div>
        <div
          className="action-group-nav action-group-nav-next"
          style={{ display: translate === max ? 'none' : 'block' }}
        >
          <button
            type="button"
            data-wx-actionbutton=""
            title={t('Next filter', { ns: 'search' })}
            onClick={onNext}
          >
            <i className="icon-chevron-right no-margin" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBarSlider;
